export const LOGO_VARIANTS = {
    DEFAULT: 'default',
    CI: 'ci',
    HIDDEN: 'hidden',
    PRIDE: 'pride',
    GYM_10_YEARS: 'gym-10-years',
    GYM_AND_BARMER: 'gym-and-barmer',
}
